import { motion } from 'framer-motion';
import * as Lucide from 'lucide-react';
import { SUSTAINABILITY } from '../../data/content';
import { SUSTAIN } from '../../constants/testIds';

export const Sustainability = () => {
  return (
    <section
      id="sustainability"
      data-testid={SUSTAIN.root}
      className="relative bg-[#18342A] text-[#F5F1E8] py-24 lg:py-32 grain-overlay overflow-hidden"
    >
      <div className="px-6 md:px-10 lg:px-16 max-w-[1500px] mx-auto relative z-10">
        <div className="grid grid-cols-12 gap-8 lg:gap-16 items-end mb-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="col-span-12 lg:col-span-8"
          >
            <div className="flex items-center gap-4 mb-6">
              <span className="w-10 h-px bg-[#C9A458]" />
              <span className="text-[11px] tracking-[0.4em] uppercase text-[#C9A458]">
                Built Lightly
              </span>
            </div>
            <h2 className="font-serif text-[#F5F1E8] text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight font-light">
              Four promises
              <br />
              we make to <em className="not-italic text-[#C9A458]">every plot</em>.
            </h2>
          </motion.div>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="col-span-12 lg:col-span-4 text-[#F5F1E8]/70 text-base leading-relaxed font-light"
          >
            From the Miyawaki forest belt that wraps the community, to the
            published per-square-foot rate every customer pays — the same way.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#F5F1E8]/10">
          {SUSTAINABILITY.map((s, i) => {
            const Icon = Lucide[s.icon] ?? Lucide.Leaf;
            return (
              <motion.div
                key={s.title}
                data-testid={SUSTAIN.item(i)}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                className="group relative bg-[#18342A] p-8 lg:p-10 hover:bg-[#1f4233] transition-colors duration-500"
              >
                <div className="flex items-start justify-between mb-10">
                  <span className="text-[#9BA58D] text-[10px] tracking-[0.4em] uppercase">
                    0{i + 1}
                  </span>
                  <Icon
                    size={36}
                    strokeWidth={1.2}
                    className="text-[#C9A458] group-hover:text-[#F5F1E8] transition-colors duration-500"
                  />
                </div>
                <h3 className="font-serif text-[#F5F1E8] text-2xl lg:text-3xl leading-snug mb-4 font-light">
                  {s.title}
                </h3>
                <p className="text-[#F5F1E8]/65 text-sm leading-relaxed font-light">
                  {s.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Sustainability;
